import React, { useState, useEffect } from 'react';
import { AlertCircle, X } from 'lucide-react';
import './SessionExpired.css';

export default function SessionExpired({ onDismiss, onLogin }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Animate in
    requestAnimationFrame(() => setVisible(true));
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    setTimeout(() => onDismiss?.(), 200);
  };

  const handleLogin = () => {
    setVisible(false);
    setTimeout(() => onLogin?.(), 200);
  };

  return (
    <div className={`session-expired-toast ${visible ? 'visible' : ''}`}>
      <div className="session-expired-icon">
        <AlertCircle size={20} />
      </div>
      <div className="session-expired-content">
        <p className="session-expired-title">Session expired</p>
        <p className="session-expired-text">Please sign in again to continue.</p>
      </div>
      <button className="session-expired-login" onClick={handleLogin}>
        Sign In
      </button>
      <button className="session-expired-close" onClick={handleDismiss} aria-label="Dismiss">
        <X size={16} />
      </button>
    </div>
  );
}
